import { supabase } from '@/integrations/supabase/client';

// Check if email is already registered
export const checkEmailExists = async (email: string): Promise<{ exists: boolean; error?: string }> => {
  try {
    console.log('🔍 Checking if email exists:', email);
    
    // Check in auth.users through admin API
    const { data, error } = await supabase.rpc('check_email_exists', {
      email_address: email.toLowerCase().trim()
    });

    if (error) {
      console.error('Email check error:', error);
      return { exists: false, error: 'Unable to verify email availability' };
    }

    console.log('📧 Email check result:', { exists: data });
    return { exists: !!data };

  } catch (error) {
    console.error('Email validation error:', error);
    return { exists: false, error: 'Email validation failed' };
  }
};

// Validate email format
export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Comprehensive email validation
export const validateEmailForRegistration = async (email: string): Promise<{
  isValid: boolean;
  error?: string;
}> => {
  // Sanitize email
  const sanitizedEmail = email.toLowerCase().trim();
  
  // Check format
  if (!isValidEmail(sanitizedEmail)) {
    return { isValid: false, error: 'Please enter a valid email address' };
  }
  
  // Check if already exists
  const existsCheck = await checkEmailExists(sanitizedEmail);
  if (existsCheck.error) {
    return { isValid: false, error: existsCheck.error };
  }
  
  if (existsCheck.exists) {
    return { 
      isValid: false, 
      error: 'This email address is already registered. Please use a different email or try logging in.' 
    };
  }
  
  return { isValid: true };
};